import { defineNamespace } from '../core';
import { en } from './en';
import { fr } from './fr';

export const payment = defineNamespace('payment', fr, en);
